import React, { useEffect, useState } from "react";
import { BookDayOfficeType } from "../../configs/DeclareType";
import ListCard from "../Components/ListCard";
import {
  handleBookDayOfficeService,
  handleClickCardShowMarker,
} from "../../services/BookServices";
import { CARD_TYPE_ROOM, DAY_OFFICE_TYPE } from "../../configs/Constants";
import { useDispatch, useSelector } from "react-redux";
import {
  dayOfficeFilterDataSelector,
  propertyFilterKeywordSelector,
} from "../../selectors/BookSelectors";
import { dayOfficeFavoriteThunk } from "../../thunks/BookThunks";
import { BOOK_DAY_OFFICE_DETAIL_WITH_DEFAULT_DATE_LINK } from "../../../App/configs/ListRoutes";
import { Accordion } from "semantic-ui-react";

type Props = {
  data: BookDayOfficeType[];
  favoriteSection?: boolean;
};

const DayOfficeListRender = ({ data, favoriteSection }: Props) => {
  const dispatch = useDispatch();
  const propertyFilterKeyword = useSelector(propertyFilterKeywordSelector);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(true);
  const filters = useSelector(dayOfficeFilterDataSelector);

  const _checkDataLength = () => {
    if (favoriteSection) {
      return data.some(({ is_favorite }) => is_favorite);
    }
    return data.some(({ is_favorite }) => !is_favorite);
  };

  const _checkFavoriteLength = () => {
    return data.some(({ is_favorite }) => is_favorite);
  };

  useEffect(() => {
    setShow(_checkDataLength());
  }, [data]);

  if (!show) {
    return null;
  }

  return (
    <Accordion>
      <Accordion.Title
        active={!_checkFavoriteLength() ? true : open}
        index={0}
        onClick={() => setOpen((prevState) => !prevState)}
      >
        {favoriteSection ? (
          <>
            Favorites
            <i className="uil uil-angle-down" />
          </>
        ) : _checkFavoriteLength() ? (
          <>
            Day Offices
            <i className="uil uil-angle-down" />
          </>
        ) : (
          ""
        )}
      </Accordion.Title>
      <Accordion.Content active={!_checkFavoriteLength() ? true : open}>
        {data
          .filter(
            ({
              name,
              address,
              company_name,
              property_name,
              property_address = "",
            }) =>
              name
                .toLowerCase()
                .includes(propertyFilterKeyword.toLowerCase()) ||
              company_name
                .toLowerCase()
                .includes(propertyFilterKeyword.toLowerCase()) ||
              property_name
                .toLowerCase()
                .includes(propertyFilterKeyword.toLowerCase()) ||
              property_address
                .toLowerCase()
                .includes(propertyFilterKeyword.toLowerCase()) ||
              address
                .toLowerCase()
                .includes(propertyFilterKeyword.toLowerCase())
          )
          .map((item) => {
            if (favoriteSection && !item.is_favorite) {
              return null;
            }

            const {
              day_office_id,
              name,
              property_name,
              company_name,
              address,
              capacity,
              thumbnail,
              rate_per_hour,
              currency,
              is_favorite,
              lat,
              lng,
              display_new_label,
              distance,
              full_day_price,
              auto_price_calculation,
              daily_rate,
            } = item;

            const office = property_name + " • " + company_name;
            const price = currency + " " + rate_per_hour;

            return (
              <ListCard
                fullDayPrice={
                  auto_price_calculation ? "" : full_day_price || daily_rate
                }
                cardType={CARD_TYPE_ROOM}
                distance={distance}
                id={day_office_id}
                key={day_office_id}
                name={name}
                office={office}
                address={address}
                capacity={capacity}
                thumbnailUrl={thumbnail}
                rating={null}
                price={price}
                currencyCode={currency}
                unit={"HR"}
                lat={lat}
                lng={lng}
                isFavorite={Boolean(is_favorite)}
                favoriteCallback={async () =>
                  await dispatch<any>(
                    dayOfficeFavoriteThunk({
                      isFavorite: is_favorite,
                      id: day_office_id,
                    })
                  )
                }
                bookCallback={() => handleBookDayOfficeService(item)}
                onClickCallback={() =>
                  handleClickCardShowMarker({
                    lat,
                    lng,
                    id: day_office_id,
                    name,
                    address,
                    type: DAY_OFFICE_TYPE,
                    capacity,
                    rating: 4,
                    price,
                    unit: "HR",
                    isFavorite: is_favorite,
                    office,
                    thumbnailUrl: thumbnail,
                  })
                }
                goToDetailLink={BOOK_DAY_OFFICE_DETAIL_WITH_DEFAULT_DATE_LINK.replaceAll(
                  ":id",
                  String(day_office_id)
                )
                  .replaceAll(":defaultDate", filters?.defaultDate)
                  .replaceAll(":defaultStartTime", filters?.defaultStartTime)
                  .replaceAll(":defaultDuration", filters?.defaultDuration)}
                newBadge={display_new_label}
              />
            );
          })}
      </Accordion.Content>
    </Accordion>
  );
};

export default DayOfficeListRender;
